<script lang="ts" setup>
import Box from './Box.vue';
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { $fetch } = useFetch();

const { data: count } = useAsyncData(
  'home:index:data',
  () => $fetch('/community/statistics', { method: 'post' }),
);
</script>

<template>
  <Box :title="$t('home.home.datacard.title')" class="mt-20" v-if="count">
    <ul class="text-16 text-#2d2d2d font-medium leading-16">
      <li class="mt-20 h-40 flex-y-center justify-between">
        <div class="flex-y-center gap-12">
          <img src="@/home/assets/home/repo.png" class="size-40 object-cover">
          <p>{{ $t('home.home.datacard.repos') }}</p>
        </div>
        <p class="text-25 text-#2d2d2d font-extrabold">{{ count.repos }}</p>
      </li>
      <li class="mt-20 h-40 flex-y-center justify-between">
        <div class="flex-y-center gap-12">
          <img src="@/home/assets/home/star.png" class="size-40 object-cover">
          <p>{{ $t('home.home.datacard.stars') }}</p>
        </div>
        <p class="text-25 text-#2d2d2d font-extrabold">{{ count.stars }}</p>
      </li>
      <li class="mt-20 h-40 flex-y-center justify-between">
        <div class="flex-y-center gap-12">
          <img src="@/home/assets/home/pr.png" class="size-40 object-cover">
          <p>{{ $t('home.home.datacard.pr') }}</p>
        </div>
        <p class="text-25 text-#2d2d2d font-extrabold">{{ count.pullRequests }}</p>
      </li>
      <li class="mt-20 h-40 flex-y-center justify-between">
        <div class="flex-y-center gap-12">
          <img src="@/home/assets/home/fork.png" class="size-40 object-cover">
          <p>{{ $t('home.home.datacard.fork') }}</p>
        </div>
        <p class="text-25 text-#2d2d2d font-extrabold">{{ count.forks }}</p>
      </li>
    </ul>
  </Box>
</template>

<style lang="scss" scoped>
</style>
